var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFblogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.25 0 0 11.225 0 25.0501C0 37.5501 9.15 47.925 21.1 49.8V32.3H14.75V25.0501H21.1V19.525C21.1 13.25 24.825 9.8 30.55 9.8C33.275 9.8 36.125 10.275 36.125 10.275V16.45H32.975C29.875 16.45 28.9 18.375 28.9 20.3501V25.0501H35.85L34.725 32.3H28.9V49.8C34.791 48.8695 40.1555 45.8638 44.0247 41.3251C47.894 36.7865 50.0135 31.0141 50 25.0501C50 11.225 38.75 0 25 0Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFblogo);
export default __webpack_public_path__ + "static/media/fblogo.4b2293ce31cbd95bc31e9be195ee1337.svg";
export { ForwardRef as ReactComponent };